/// <amd-module name="Reporting/Visuals/VisualMessages/NoDataMessage" />
import * as React from "react";
import * as Resources from "Reporting/Visuals/Resources";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { Size, VisualMessageBase } from "./VisualMessageBase";

export interface NoDataProps {
    visualTitle: string;
    size: Size;
    cardId?: number;
    hideTitle?: boolean;
}

/** Used for Rendering "No Data" Experiences for Charting-centric visuals. */
export class NoDataMessage extends VssComponent<NoDataProps, {}> {
    public static numberOfZeroResultImages: number = 7;
    public render(): JSX.Element {
        return (
            <VisualMessageBase
                visualTitle={this.props.visualTitle}
                messageContent={format(Resources.NoData_Message, "")}
                size={this.props.size}
                imagePath={this.getEmptyChartResourcePath(this.props.cardId)}
                altText={Resources.NoData_AltText}
                hideTitle={this.props.hideTitle}
            />
        );
    }

    public getEmptyChartResourcePath(cardId?: number): string {
        if (cardId) {
            cardId = Math.abs(cardId) % NoDataMessage.numberOfZeroResultImages;
        } else {
            cardId = Math.floor(Math.random() * NoDataMessage.numberOfZeroResultImages);
        }
        const location = `ms.vss-reporting/reporting-visuals-common/images/chart-noresult-${cardId}.png`;
        return location;
    }
}
